import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GenAiMainService {
httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  GetAllPoc() {
    const url = `${this.apiUrl}Poc/GetAllPOC`;
    return this.http.get<any>(url, this.httpOptions);
  }

  AddPoc(requestData)
  {
    const url = `${this.apiUrl}Poc/CreatePOC`;
    return this.http.post<any>(url,requestData,this.httpOptions);
  }

  EditPoc(requestData)
  {
    const url = `${this.apiUrl}Poc/UpdatePOC`;
    return this.http.put<any>(url,requestData,this.httpOptions);
  }

  DeletePoc(id:number)
  {
    const url = `${this.apiUrl}Poc/DeletePOC?pocId=${id}`;
    return this.http.delete<any>(url,this.httpOptions);
  }

  GetAllTechStack()
  {
    const url = `${this.apiUrl}Poc/GetAllTechStack`;
    return this.http.get<any>(url,this.httpOptions);
  }

  addRating(data)
  {
    const url = `${this.apiUrl}Poc/AddRating`;
    return this.http.post<any>(url,data,this.httpOptions);
  }

  getSearchPOC(searchText)
  {
    const url = `${this.apiUrl}Poc/SearchPoc?searchText=${searchText}`;
    return this.http.get<any>(url,this.httpOptions);
  }

  updateViewCount(pocId)
  {
    const url = `${this.apiUrl}Poc/UpdateViewCount?pocId=${pocId}`;
    return this.http.put<any>(url,this.httpOptions);
  }

  updateLastViewedOn(request)
  {
    const url = `${this.apiUrl}Poc/UpdateLastViewedOn`;
    return this.http.put<any>(url,request,this.httpOptions);
  }

  GetRecentlyViewedPocs(){
    const url = `${this.apiUrl}Poc/GetRecentlyViewedPocs`;
    return this.http.get<any>(url,this.httpOptions);
  }

  getTopRated(count:number)
  {
    const url = `${this.apiUrl}Poc/GetTopRated?count=${count}`;
    return this.http.get<any>(url,this.httpOptions);
  }

  getPaginationData(searchTxt,from,size)
  {
    const url = `${this.apiUrl}Poc/GetAllPocData?searchTxt=${searchTxt}&from=${from}&size=${size}`;
    return this.http.get<any>(url,this.httpOptions);
  }
}
